import React from "react"
import "./Skills.css"
import data from "./Skills-Api"
import Card from "./Card"

const Skills = () => {
  return (
    <>
      <section className='skills' id='skills'>
        <div className='container'>
          <div className='heading'>
            <h1>My Skills</h1>
          </div>

          <div className='content grid'>
            {data.map((val, index) => {
              return <Card key={index} image={val.image} title={val.title} />
            })}
          </div>
        </div>
      </section>
    </>
  )
}

export default Skills
